/** https://docs.tsafe.dev/assert */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function assert(condition, msg) {
    if (!condition) {
        throw new Error(msg);
    }
}
